import {useEffect, useRef, useState} from "react";
import styled from "styled-components";
import {DebounceInput} from "react-debounce-input";
import {CircularProgress} from "@mui/material";
import CancelIcon from "../assets/createEnvAssets/CancelIcon";
import {DropDownTabs} from "./demoPointEnv/createEnv/components/steps/secondStep/AccountDropdown";
import DropdownOptions from "./threatGuard/DropdownOptions";

const DropdownContainer = styled.div`
  position: relative;
`;

const DropdownSearch = styled(DebounceInput)`
  width: 100%;
  height: 38px;
  background: #FFFFFF;
  border: 1px solid #E5E5E5;
  border-radius: 3px;
  padding-left: 10px;
  border-right-style: none;

  &:focus-visible {
    outline-color: #EC407A;
  }
`;

const InputSearch = styled.div`
  margin-top:4px ;
  display: flex;
  position: relative;

  .delete-search {
    background: #FFFFFF;
    border: 1px solid #E5E5E5;
    border-radius: 3px;
    padding-left: 10px;
    border-left-style: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-right: 10px;
  }
`;
const CircularProgressWrapper = styled.div`
  position: absolute;
  right: 37px;
  top: 8px;
`;
const CustomDropdown = (props) => {
    const {isLoading, list, setSearchInput, searchInput,rowSelected,setRowSelected} = props;
    const [listening, setListening] = useState(false);
    const menuRef = useRef(null);
    const [isHidden, setIsHidden] = useState(true);


    function listenForOutsideClicks(listening, setListening, menuRef) {
        return () => {
            if (listening) return;
            if (!menuRef.current) return;
            setListening(true);
            [`click`, `touchstart`].forEach((type) => {
                document.addEventListener(`click`, (evt) => {
                    if (menuRef?.current?.contains(evt.target)) return;
                    setIsHidden(true)
                });
            });
        }
    }

    useEffect(listenForOutsideClicks(
        listening,
        setListening,
        menuRef,
    ));


    const handleChange = (e) => {
        setSearchInput(e.target.value);
        if(rowSelected.value === ""){
            setRowSelected({value:e.target.value,label:""})
        }
    }
    const deleteSearch = () => {
        setSearchInput("");
        setRowSelected({value:"",label:""});
    }
    const handleSelection = (selected) => {
        setRowSelected(selected);
        setIsHidden(true);
    }
    return (
        <DropdownContainer ref={menuRef}>
            <InputSearch>
                <DropdownSearch type={"text"}
                                placeholder={"Start Typing Account Name"}
                                className={"dropdown-search"}
                                minLength={3}
                                debounceTimeout={800}
                                onChange={handleChange}
                                onClick={() => setIsHidden(false)}
                                value={rowSelected.value === "" ? searchInput : rowSelected.value}
                                id={"account_search"}
                                autoComplete={"off"}/>
                {isLoading && <CircularProgressWrapper>
                    <CircularProgress size={20} sx={{color: "#EC407A"}}/>
                </CircularProgressWrapper>}
                <div className={"delete-search"} onClick={deleteSearch}>
                    <CancelIcon/>
                </div>
            </InputSearch>
            <DropDownTabs hide={isHidden}>
                <DropdownOptions list={list} handleSelection={handleSelection}/>
            </DropDownTabs>
        </DropdownContainer>
    );
}

export default CustomDropdown;
